var map = {
	"./card-icons/card-back.png": 562,
	"./card-icons/club-icon.svg": 898,
	"./card-icons/club.svg": 734,
	"./card-icons/diamond-icon.svg": 403,
	"./card-icons/diamond.svg": 139,
	"./card-icons/heart-icon.svg": 364,
	"./card-icons/heart.svg": 404,
	"./card-icons/jack.png": 409,
	"./card-icons/king.png": 246,
	"./card-icons/queen.png": 595,
	"./card-icons/spade-icon.svg": 838,
	"./card-icons/spade.svg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;